/** Values of the `cat` field of the Wesub product feed, lowercased. */
const NEW_FEED_CATEGORY = "nowości";
const TOP_OFFER_FEED_CATEGORY = "oferta tygodnia";

const hasFeedCategory = (product: WesubProduct, needle: string): boolean =>
  (product.custom?.categories ?? []).some(
    (category) => category.trim().toLowerCase() === needle,
  );

/**
 * Products cached before the `isNew` flag existed still carry the raw feed
 * categories, so fall back to those.
 */
export const isNewProduct = (product: WesubProduct): boolean =>
  product.custom?.isNew ?? hasFeedCategory(product, NEW_FEED_CATEGORY);

export const isTopOfferProduct = (product: WesubProduct): boolean =>
  product.custom?.isTopOffer ??
  hasFeedCategory(product, TOP_OFFER_FEED_CATEGORY);
